// extracted by mini-css-extract-plugin
export default {"containprod":"XT","containprod2":"YT","title":"ZT","servings":"aU","recommendation":"bU","image":"cU","flavorswrap":"eU","flavorsgroupwrap":"fU","moredetailsWrap":"gU","infoWrap":"hU","price":"iU","regularPrice":"jU","netPrice":"kU","addtocartcontainer":"lU","error":"mU"};
    if(module.hot) {
      // 1738836197850
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  